import { NgModule } from '@angular/core'
import {
  CartBaseRootModule,
  CART_BASE_FEATURE,
  ADD_TO_CART_FEATURE,
  MINI_CART_FEATURE
} from '@spartacus/cart/base/root'
import { CmsConfig, provideConfig } from '@spartacus/core'

@NgModule({
  imports: [CartBaseRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [CART_BASE_FEATURE]: {
          module: () => import('../../../features/cart/custom-cart.module').then((m) => m.CustomCartModule)
        }
      }
    }),
    provideConfig(<CmsConfig>{
      featureModules: {
        [ADD_TO_CART_FEATURE]: {
          module: () =>
            import('../../../features/cart/add-to-cart/custom-add-to-cart.module').then((m) => m.CustomAddToCartModule)
        }
      }
    }),
    provideConfig(<CmsConfig>{
      featureModules: {
        [MINI_CART_FEATURE]: {
          module: () =>
            import('../../../features/cart/mini-cart/custom-mini-cart.module').then((m) => m.CustomMiniCartModule)
        }
      }
    })
  ]
})
export class CartBaseFeatureModule {}
